import { connect } from "react-redux";
import { put, call, select, takeEvery,  spawn, cancel, cancelled, all, throttle } from "redux-saga/effects";
import { createAction } from "redux-delta";
import { asyncDelta } from "redux-delta/lib/dx/async";
import { fetchFactory, takeOnlyLeading,  debounceFor } from "../saga";
import { callbackToBotSaga } from "../webview";
import { militaryTime } from "../../utils/time";
import { dtsApi } from "../../api";
import { trackRemoveHourSaga, trackAddHourSaga, trackEditHourSaga,
  trackAddDaySaga, trackRemoveDaySaga } from "../mixpanel"
import uniqueBy from "lodash/uniqBy";

export const dailytexts = asyncDelta("dailytexts", { loading: true });

// SAGA WORKERS
export const fetchDailyTexts = createAction("FETCH_DAILY_TEXTS");
const fetchDailyTextsSaga = fetchFactory(dailytexts, ({ user_id }) =>
  dtsApi.fetchDailyTexts(user_id)
);

export const updateDailyTexts = createAction("UPDATE_DAILY_TEXTS");

function* optimisticDailyTextsSaga({ payload }) {
  yield put(dailytexts.setSuccess(payload));
}

function* updateDailyTextsSaga({ payload }) {
  try {
    yield put(dailytexts.setFailure(""));
    yield call(dtsApi.updateDailyTexts, payload);
    yield put(dailytexts.setLoading(false));
  } catch (e) {
    yield put(dailytexts.setLoading(false));
    yield put(dailytexts.setFailure(e.message));
  }
}

function* sendUpdateConfirmation() {
  try {
    yield call(callbackToBotSaga, "___NOTIFICATIONS_UPDATED___");
  }
  catch (e) {
    if(yield cancelled()) {
      console.log("cancelled finally")
    } else {
      console.log(e)
    }
  }
}
const cancelNotification = createAction("CANCEL_NOTIFICATION")


const setHours = createAction("SET_DAILY_TEXTS_HOURS");
const createHours = createAction("CREATE_DAILY_TEXTS_HOURS");
const setHoursSaga = function*({ payload: hours }) {
  const { user_id, days } = yield select(selectDailyTextsData);
  yield put(
    updateDailyTexts({
      user_id,
      days,
      hours: uniqueBy(hours, militaryTime)
    })
  );
};

const removeHours = createAction("REMOVE_DAILY_TEXTS_HOURS");
const removeHoursSaga = function*({ payload: deletedHour }) {
  const { user_id, hours, days } = yield select(selectDailyTextsData);
  yield put(
    updateDailyTexts({
      user_id,
      days,
      hours: [].concat(hours)
        .filter(v => militaryTime(v) !== militaryTime(deletedHour))
    })
  );
};

const createDays = createAction("CREATE_DAILY_TEXTS_DAYS");
const removeDays = createAction("REMOVE_DAILY_TEXTS_DAYS");
const toggleDaySaga = function*({ payload: day }) {
  const { user_id, hours, days } = yield select(selectDailyTextsData);
  yield put(
    updateDailyTexts({
      user_id,
      hours,
      days: days.includes(day) ? days.filter(v => v !== day) : days.concat(day)
    })
  );
};

const resetDailyTexts = createAction("RESET_DAILY_TEXTS");
const resetDailyTextsSaga = function*() {
  const { user_id } = yield select(selectDailyTextsData);
  yield put(
    updateDailyTexts({
      user_id,
      hours: [],
      days: []
    })
  );
};

// SELECTORS
export const selectDailyTexts = ({ dailytexts = {} }) => dailytexts;
export const selectDailyTextsData = ({ dailytexts = {} }) =>
  dailytexts.data || { hours: [], days: [] };

// CONNECTORS
const actions = {
  fetchDailyTexts,
  updateDailyTexts,
  setHours,
  removeHours,
  createHours,
  createDays,
  removeDays,
  resetDailyTexts
};

export const withDailyTextsData = connect(
  selectDailyTextsData,
  actions
);

export const withDailyTexts = connect(
  selectDailyTexts,
  actions
);

export const withCancelNotification = connect(() => ({}), { cancelNotification })

// SAGA WATCHER
export default function* dailyTextSaga() {
  yield takeEvery(fetchDailyTexts.type, fetchDailyTextsSaga);
  yield takeEvery(updateDailyTexts.type, optimisticDailyTextsSaga);

  const updateTask = yield takeOnlyLeading(updateDailyTexts.type, sendUpdateConfirmation);
  yield spawn(function*() {
    yield takeOnlyLeading(cancelNotification.type, function*() {
      yield cancel(updateTask);
    })
  });

  yield takeEvery(setHours.type, trackEditHourSaga);
  yield takeEvery(createHours.type, trackAddHourSaga);
  yield takeEvery([setHours.type, createHours.type], setHoursSaga);

  yield takeEvery(removeHours.type, trackRemoveHourSaga);
  yield takeEvery(removeHours.type, removeHoursSaga);

  yield takeEvery(createDays.type, trackAddDaySaga);
  yield takeEvery(removeDays.type, trackRemoveDaySaga);
  yield takeEvery([createDays.type, removeDays.type], toggleDaySaga);

  yield takeEvery(resetDailyTexts.type, resetDailyTextsSaga);
  yield debounceFor(updateDailyTexts.type, updateDailyTextsSaga, 1000);
}



// WEBPACK FOOTER //
// ./src/store/dailytexts/index.js